import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import { Pencil } from "lucide-react-native";
import { Text } from "@src/packages/medical-history/components/MedicalHistoryText";
import {
  QuestionLayout,
  IconInput,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useFamilyHistory } from "../FamilyHistoryContext";
import type { FamilyHistoryStackParamList } from "../FamilyHistoryNavigator";
import { useMedicalHistoryTheme } from "../../theme/MedicalHistoryTheme";

export function MaternalDiseasesScreen() {
  const t = useTranslations();
  const { state, updateState } = useFamilyHistory();
  const navigation =
    useNavigation<NavigationProp<FamilyHistoryStackParamList>>();
  const theme = useMedicalHistoryTheme();

  const handleNext = () => {
    navigation.navigate("PaternalDiseases");
  };

  return (
    <QuestionLayout
      title={t("med_history.family_history.maternal_diseases_title")}
      subtitle={t("med_history.family_history.maternal_diseases_description")}
      onBack={() => navigation.goBack()}
      onSave={handleNext}
      saveDisabled={false}
      saveLabel={t("med_history.shared.next")}
    >
      <View style={styles.container}>
        <Text style={[styles.example, { color: theme.textFaint }]}>
          {t("med_history.family_history.maternal_diseases_example")}
        </Text>

        <IconInput
          icon={Pencil}
          label={t("med_history.family_history.diseases_label")}
          placeholder={t("med_history.family_history.diseases_placeholder")}
          value={state.diseasesMothersSide ?? ""}
          onChangeText={(text) =>
            updateState({ diseasesMothersSide: text || null })
          }
          multiline
          numberOfLines={4}
        />
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginBottom: 40,
  },
  example: {
    fontSize: 13,
    textAlign: "center",
    marginBottom: 24,
    lineHeight: 20,
  },
});
